<h6 *ngIf="label" class="u-color-muted u-margin-bottom-half">{{ label }}</h6>
<ui-toggle-group
    [options]="toggleGroupOptions | translateProp"
    (valueChange)="filterBySource($event)"
    [value]="currentValue"
    class="u-w100p"
></ui-toggle-group>
